import React from 'react';
import styles from './CategoryGrid.module.scss';
import Icon from '../Icon/Icon';
import { useNavigate } from 'react-router-dom';
import PodcastIcon from '../AddCategory/PodcastIcon';
import MusicIcon from '../AddCategory/MusicIcon';

export const categoriesProps = [
  // { icon: 'library-music', title: 'Music', color: "#ffffff", stroke: "#ff0000", value: "music" },
  { icon: 'library-artwork', title: 'Artwork', color: "#ff0000", value: "artwork" },
  { icon: 'library-music', title: 'Music', value: 'music', iconComp: <MusicIcon width={56} color="#ff0000" />, activeIconComp: <MusicIcon width={48} color="#FF3232" /> },
  // { icon: 'library-podcast', title: 'Podcast', color: "#ffffff", stroke: "#ff0000", value: "podcast" },
  { icon: 'library-photography', title: 'Photography', color: "#ff0000", value: "photography" },
  { icon: 'library-video', title: 'Film', color: "#ff0000", value: "video" },
  { icon: 'library-podcast', title: 'Podcast', value: 'podcast', iconComp: <PodcastIcon width={56} color="#ff0000" />, activeIconComp: <PodcastIcon width={48} color="#FF3232" /> },
  { icon: 'library-book', title: 'Book', color: "#ff0000", value: "book" },
  { icon: 'library-clothing', title: 'Clothing', color: "#ff0000", value: "clothing" },
  {
    icon: 'library-handmade', title: 'Craft', color: "#ff0000", value: "handmade_craft"
  },
];

const CategoryGrid = () => {
  const navigate = useNavigate()

  const handleCategoryClick = (category) => {
    navigate(`/collection/${category}`)
  }

  return (
    <div className={`${styles.categoriesSection} mb-0`}>
      <div className={`${styles.categoriesTitle} d-flex aic mb-8`}>Your Collection <Icon alias="chevron-right" className="ml-8" width={20} stroke="#FF3232" /></div>
      <div className={`${styles.categoriesGrid} mb-8`}>
        {categoriesProps.map((cat, idx) => (
          <div onClick={() => handleCategoryClick(cat.value)} className={`${styles.categoryCard} p-0`} key={idx}>
            <div className={styles.categoryIcon}>
              {cat.iconComp ?
                (cat.iconComp) :
                <Icon alias={cat.icon} color={cat.color} stroke={cat.stroke} width={48} />
              }
            </div>
            <span className={styles.categoryLabel}>{cat.title}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CategoryGrid; 